import {property} from "lit/decorators/property.js";
import {AbstractInputComponent} from "./_inputs/abstract-input.component";

export abstract class AbstractLitInputComponent<T> extends AbstractInputComponent {

    @property({type: Object})
    public value: T | null = null;

}